import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import Toggle from "react-toggle";
import {useDispatch} from "react-redux";
import {
  createDowntimeAlert,
  createMetricAlert,
  createSensorDowntimeAlert,
  toggleAlertState,
} from "../../../redux/Actions/alerts.actions";
import {useFetchSensorAlerts} from "../../SensorAlerts/sensorAlertsTable/useSensorAlertTableData";
import {useFetchAlerts} from "./useAlertTableData";

const AlertsCard = ({alertType = "system", data, isStaffOrSuperuser = false}) => {
  const {
    enabled,
    inventory_name = "",
    level = "",
    location_name = "",
    name = "",
    sensor_name = "",
    site_name = "",
    type = "",
    updated_at,
    user_email = "",
  } = data;

  const dispatch = useDispatch();

  const handleToggle = () => {
    dispatch(
      toggleAlertState({
        id: data.id,
        requestData: {enabled: !data.enabled},
      })
    );
  };

  return (
    <CardBody>
      <CardTitle tag="h4">
        Type <CardText>{type}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Name <CardText>{name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Level <CardText>{level}</CardText>{" "}
      </CardTitle>
      {isStaffOrSuperuser && (
        <CardTitle tag="h4">
          User Email <CardText>{user_email}</CardText>
        </CardTitle>
      )}
      <CardTitle tag="h4">
        Site: <CardText>{site_name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Location: <CardText>{location_name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Appliance <CardText>{inventory_name}</CardText>{" "}
      </CardTitle>
      {sensor_name && (
        <CardTitle tag="h4">
          Sensor <CardText>{sensor_name}</CardText>
        </CardTitle>
      )}
      <CardTitle tag="h4">
        Enabled{" "}
        <div className="enable-alarm">
          <Toggle checked={enabled} onChange={handleToggle} />
        </div>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        SMS Notifications{" "}
        <div className="enable-alarm">
          <RenderSmsNotification alertType={alertType} data={data} />
        </div>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Updated At <CardText>{updated_at}</CardText>{" "}
      </CardTitle>
    </CardBody>
  );
};

export default AlertsCard;

const RenderSmsNotification = ({alertType = "system", data}) => {
  const dispatch = useDispatch();
  const {refetch} = useFetchAlerts();
  const {refetch: refetchSensorAlerts} = useFetchSensorAlerts();

  const callback = () => {
    if (alertType === "sensor") {
      refetchSensorAlerts();
    } else {
      refetch();
    }
  };

  const action =
    alertType === "sensor"
      ? createSensorDowntimeAlert
      : data.type === "Metric"
        ? createMetricAlert
        : createDowntimeAlert;

  const handleToggle = () => {
    dispatch(
      action(
        {
          ...data,
          mac: data.inventory,
          sms_enabled: !data.sms_enabled,
        },
        data.id,
        callback
      )
    );
  };
  return <Toggle checked={data.sms_enabled} onChange={handleToggle} />;
};

export const CustomRenderComponent = ({alertType = "system", data, renderKey}) => {
  if (renderKey === "sms_notifications") {
    return <RenderSmsNotification alertType={alertType} data={data} />;
  } else {
    return null;
  }
};
